import { render, staticRenderFns } from "./ModalMessageHistory.vue?vue&type=template&id=abb266e8&"
import script from "./ModalMessageHistory.vue?vue&type=script&lang=js&"
export * from "./ModalMessageHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports